<template>
  <div class="modal-img">
    <myMask></myMask>
    <div class="modal-img-win flex flex--middle flex--center">
      <div @click.stop="closeModal">
        <i class="icon-close"></i>
      </div>
      <slot name="title"></slot>
      <div class="modal-img-container" ref="modalContainer">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import myMask from './common/mask.vue'
export default {
  name: 'modal',
  components: {
    myMask
  },
  props: ['hideBtn'],
  data() {
    return {
      testBScroll: null
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss">
@import '../scss/function';
@import '../scss/components';
.modal-img {
  pointer-events: auto;
  &-win {
    position: fixed;
    top: topx(100rem);
    left: 50%;
    transform: translate(-50%, 0%);
    z-index: 11;
    width: topx(670rem);
    height: topx(670rem);
    background: #ffffff;
    border-radius: topx(26rem);
    overflow: hidden;
    .icon-close {
      position: absolute;
      display: block;
      top: topx(21rem);
      right: topx(21rem);
      width: topx(48rem);
      height: topx(48rem);
      background: url('../assets/report/pop_btn_back.png') center no-repeat;
      background-size: topx(24rem);
    }
    .modal-img-container {
      width: topx(500rem);
      height: topx(500rem);
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/imgDialog.vue